module.exports = __webpack_public_path__ + "bin/bbe77a0728826c1e06921e5bac4778e1.woff";